
import React, { useState } from "react";
import "./ForgeRock.css";
import MenuNavbar from "../../MenuNavbar";
import Floaticons from "../../Floaticons";
import Tabs from "@mui/material/Tabs";
import PropTypes from "prop-types";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IdentiyAccessManagement from "../IdentityManagement/IdentityandAccessManagement";
import InfrastructureSecurity from "../InfrastructureSecurity/InfrastructureSecurity";
import PlatformSecurity from "../PlatformSecurity/PlatformSecurity";
import CloudSecurity from "../CloudSecurity/CloudSecurity";
import Link from "@mui/material/Link";
import HomeIcon from "@mui/icons-material/Home";
import { Breadcrumbs } from "@material-ui/core";

import ForgeRockData from "../../Data/ForgeRockData.json";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 4 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function ForgeRock() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [showMore, setShowMore] = useState();

  return (
    <>
      <div className="banner-container">
        <img
          src="images/SecuritySchools/SailPoint/school-banner.png"
          alt="banner"
          className="banner-img"
        />
        <div className="breadcrumbs-container">
          <Breadcrumbs separator=">" color="#fff">
            <Link
              underline="hover"
              sx={{ display: "flex", alignItems: "center" }}
              color="#fff"
              href="/"
            >
              <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            </Link>
            ,
            <Link
              underline="hover"
              key="2"
              color="#fff"
              href="/securityLearningFramework"
              // onClick={handleClick}
            >
              Security Learning Framework
            </Link>
            ,
            <Typography key="3" color="#fff">
              Security Schools
            </Typography>
            ,
          </Breadcrumbs>
        </div>
        <div className="banner-content">
          <h1>Security Schools</h1>
          <i>
            Lorem ipsum is a dummy text of the printing and typesetting industry
          </i>
        </div>
        <MenuNavbar />
      </div>
      <Floaticons />
      <div className="breadcrumbLinks">
        <Breadcrumbs separator=">" aria-label="breadcrumb">
          <a className="menu_title" href="/securitySchools">
            <img src="/images/SecuritySchools/Back-button.png" />
            Security Schools and Bootcamps​
          </a>
          {value === 0 ? (
            <a className="menu_title" href="/securitySchools#I&DInitiatives">
              Identity & Access Management
            </a>
          ) : (
            ""
          )}
          {value === 1 ? (
            <a
              className="menu_title"
              href="/securitySchools#InfrastructureSecurity"
            >
              Infrastructure Security
            </a>
          ) : (
            ""
          )}
          {value === 2 ? (
            <a className="menu_title" href="/securitySchools#platformsecurity">
              Platform Security
            </a>
          ) : (
            ""
          )}
          {value === 3 ? (
            <a className="menu_title" href="/securitySchools#cloudsecurity">
              Cloud Security
            </a>
          ) : (
            ""
          )}
          <a className="menu_title" href="">
            ForgeRock
          </a>
        </Breadcrumbs>
      </div>
      <div className="main-container" id="ForgeRock">
        <Box className="boxStyles">
          <Box
            sx={{ borderBottom: 0, borderColor: "divider" }}
            className="tabMenuWrap"
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              centered
            >
              <Tab
                label="Identity & Access Management​"
                {...a11yProps(0)}
                className="tabStyles"
              />
              <Tab
                label="Infrastructure Security"
                {...a11yProps(1)}
                className="tabStyles"
              />
              <Tab
                label="Platform Security"
                {...a11yProps(2)}
                className="tabStyles"
              />
              <Tab
                label="Cloud Security"
                {...a11yProps(3)}
                className="tabStyles"
                // href='https://atci.lkm.delivery.accenture.com/ProfessionalSkills/' target='_blank'
              />
            </Tabs>
          </Box>
          <TabPanel className="tabPanelWrap" value={value} index={0}>
            <div id="">
              <div className="Oracle-AboutWrapp">
                <div className="leftImage">
                  <img
                    src="images/SecuritySchools/ForgeRock/ForgeRock-About.png"
                    alt=""
                    className="img-responsive"
                  />
                </div>
                <div className="rightContent">
                  <h2 className="SP-AboutHeading">About ForgeRock</h2>
                  <p>
                    <strong>ForgeRock</strong> is the digital identity and
                    access management <strong>(IAM)</strong> software system. ​
                  </p>
                </div>
              </div>
              <div className="tabPanel-innerWrapp">
                <div className="keyObjective-wrapper" id="Oracle-Objective">
                  <h2 className="key-obj-heading">Key Objectives:</h2>
                  <div className="obj-inner-row">
                    <div className="objectiveBox">
                      <img
                        src="images/SecuritySchools/ForgeRock/Icons/icon-1.png"
                        alt="key-objectives-icon"
                      />
                      <p>
                        Managing Access management, Identity management and
                        Directory services concepts.
                      </p>
                    </div>
                    <div className="objectiveBox">
                      <img
                        src="images/SecuritySchools/ForgeRock/Icons/icon-2.png"
                        alt="key-objectives-icon"
                      />
                      <p>
                        Protecting an application with intelligent
                        authentication.​
                      </p>
                    </div>
                    <div className="objectiveBox">
                      <img
                        src="images/SecuritySchools/ForgeRock/Icons/icon-3.png"
                        alt="key-objectives-icon"
                      />
                      <p>
                        Controlling access to an application with am
                        authorization.​
                      </p>
                    </div>
                    <div className="objectiveBox">
                      <img
                        src="images/SecuritySchools/ForgeRock/Icons/icon-4.png"
                        alt="key-objectives-icon"
                      />
                      <p>
                        Protecting Rest API's and integrating mobile
                        applications with oauth2-based protocols.
                      </p>
                    </div>
                    <div className="objectiveBox">
                      <img
                        src="images/SecuritySchools/ForgeRock/Icons/icon-5.png"
                        alt="key-objectives-icon"
                      />
                      <p>
                        Improving security with a zero-trust approach and
                        integrating with third-party saml2 entities.​​
                      </p>
                    </div>
                    <div className="objectiveBox">
                      <img
                        src="images/SecuritySchools/ForgeRock/Icons/icon-6.png"
                        alt="key-objectives-icon"
                      />
                      <p>Managing identities.​</p>
                    </div>
                    <div className="objectiveBox">
                      <img
                        src="images/SecuritySchools/ForgeRock/Icons/icon-7.png"
                        alt="key-objectives-icon"
                      />
                      <p>
                        Exercise activities on Installation, configuration of
                        ForgeRock components.​
                      </p>
                    </div>
                  </div>
                  <div className="Section3">
                    <div className="bottomContent">
                      <p class="headingWrap">
                        <span>Total Duration: 135 hours</span>
                        <p className="iconWrapper">
                          <img
                            className=""
                            src="images/SecuritySchools/IdentityGovernance​/Time-Icon.png"
                          />
                        </p>
                      </p>
                      <div className="row1-bottom-section">
                        <p className="boxBorder">
                          <span className="bold">Training model :</span>{" "}
                          <br></br>
                          <span className="light">
                            VILT + Self-Paced e-learning modules + Case study+
                            Assessment​​
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="topicIn-Focus-Wrapper">
                <div className="FocusInnerContainer">
                  <h2 className="infocusHead">Topics in Focus</h2>
                  <div className="cardRow">
                    {/* Card 1 */}
                    {ForgeRockData.Topics.map((item, i) => {
                      return (
                        <div className="Infocus-Cards" id={"card" + item.id}>
                          <h3>{item.TopicHeader}</h3>
                          <div className="InfocusList-wrapper">
                            <ul>
                              {/* {item.topiclist.li.map((item) => {
                                return <li>{item}</li>;
                              })} */}
                              {
                                  item.topiclist.li.slice(0, 8).map((item) => {
                                    return (
                                        <li>{item}</li>
                                    );
                                  })
                                }
                                {
                                  showMore==item.id &&
                                  item.topiclist.li.slice(8).map((item) => {
                                    return (
                                        <li>{item}</li>
                                    );
                                  })
                                }
                                {
                                  showMore!==item.id ? <p className="downArrow" onClick={() => setShowMore(item.id)} ><img src="images/SecuritySchools/ForgeRock/Icons/down-arrow.png" alt="down-arrow"/>
                                    </p>:<p className="upArrow" onClick={() => setShowMore()}>
                                    <img src="images/SecuritySchools/ForgeRock/Icons/Up-arrow.png" alt="up-arrow"  /></p>
                                }
                            </ul>
                          </div>
                          <span className="bottomBorder-purple"></span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel className="tabPanelWrap" value={value} index={1}>
            <InfrastructureSecurity />
          </TabPanel>
          <TabPanel className="tabPanelWrap" value={value} index={2}>
            <PlatformSecurity />
          </TabPanel>
          <TabPanel className="tabPanelWrap" value={value} index={3}>
            <CloudSecurity />
          </TabPanel>
        </Box>
      </div>
    </>
  );
}

export default ForgeRock;

